import styled, { StyledComponentProps } from "styled-components";

export const AppLogoIconStyled = styled.svg<StyledComponentProps<"svg", any, {}, never>>`
    height: ${p => p.height}px;
    min-height: ${p => p.height}px;
    width: ${p => p.width}px;
    min-width: ${p => p.width}px;
    margin-right: 15px;
    cursor: pointer;
`